<template>
    <div id="app" class="app">
        <router-view />
    </div>
</template>

<script>
    
    export default {
        name: 'App',
        data () {
			return {
            }
        },
        components:{
		}
    }
</script>

<style>
</style>






// WEBPACK FOOTER //
// src/App.vue